import { h } from "preact";
import { useEffect } from "preact/hooks";
import Macy from "macy";
import PluginItem from "../PluginItem";
var masonryOptions = {
    columns: 4,
    margin: {
        x: 12,
        y: 14,
    },
    container: ".vp-masonry-grid",
    breakAt: {
        1200: {
            columns: 3,
        },
        700: {
            columns: 2,
        },
        500: {
            columns: 1,
        },
    },
};
var Gallery = function (_a) {
    var data = _a.data, onOpenDetailsHandler = _a.onOpenDetailsHandler, onClickPlayHandler = _a.onClickPlayHandler, setIsModalOpen = _a.setIsModalOpen, isPreview = _a.isPreview;
    var pluginData = data;
    useEffect(function () {
        Macy(masonryOptions);
    }, []);
    return (h("div", { "data-testid": "gallery-plugin" },
        h("div", { className: "vp-masonry-grid" }, pluginData.content.map(function (item) { return (h("div", { className: "masonry-item", key: item.id },
            h(PluginItem, { tall: true, styles: pluginData.styles, item: item, onClickPlayHandler: onClickPlayHandler, onOpenDetailsHandler: onOpenDetailsHandler, flex: true, setIsModalOpen: setIsModalOpen, isPreview: isPreview }))); }))));
};
export default Gallery;
